import React from 'react';
import { Image, Text } from 'react-native-web';
import { getImageByKey, img_icon_add_circle } from '../../../../utils/ImagesManagementUtils';
import { xlateText } from '../../../../utils/Utils';
import PhoneHeadLineWithBackgroundColor from '../../AuxiliaryComponent/MixComponent/PhoneHeadLineWithBackgroundColor';
import FullPageSimulator from '../FullPageSimulator';
import { Dollar_100, no_results_image } from '../../../../utils/DictionaryManagementUtils';
import { textSecondary_14_0 } from '../../AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================
const Launch_empty_stateFP = ({
  globJSON,
  language,
  simPlatform,
  withoutBlueScreen,
  TopTitle,
  withOutTopVerticalLine,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { empty_state } = globJSON.configurations.launch;

  const myStyles = {
    labelStyle: {
      width: 190,
      height: 40,
      alignSelf: 'center',
      marginTop: 30,
      textAlign: 'center',
    },
    circleStyle: {
      width: 18,
      height: 18,
      marginLeft: 212,
      marginTop: -10,
      position: 'absolute',
      tintColor: colors.tertiary_icons_color,
    },
    imageStyle: {
      width: 80,
      height: 50,
      marginTop: 20,
      alignSelf: 'center',
    },
  };

  //= ====================================================================

  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      TopTitle={TopTitle}
      hidePhoneHeadLine={!withoutBlueScreen}
      hideCloseButton
      headlineText={withoutBlueScreen && globJSON.configurations.launch.empty_state.your_bills}
      withOutTopVerticalLine={withOutTopVerticalLine}
      slideshowRefs={slideshowRefs}
      withGrayCircle
    >
      {!withoutBlueScreen && (
      <PhoneHeadLineWithBackgroundColor
        globJSON={globJSON}
        simPlatform={simPlatform}
        language={language}
        inputTextMoney={Dollar_100}
      />
      )}
      <Text style={[textSecondary_14_0(globJSON, simPlatform), myStyles.labelStyle]}>
        {xlateText(empty_state.nothing_to_see_here)}
      </Text>
      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.imageStyle}
        source={getImageByKey(empty_state.empty_state_icon, no_results_image)}
      />
    </FullPageSimulator>
  );
};

export default Launch_empty_stateFP;
